var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0117 0.703125C23.9414 0.703125 24.7617 1.52344 24.7617 2.50781V23.4531C24.7617 24.4375 23.9414 25.2031 23.0117 25.2031H1.95703C1.02734 25.2031 0.261719 24.4375 0.261719 23.4531V2.50781C0.261719 1.52344 1.02734 0.703125 1.95703 0.703125H23.0117ZM7.64453 21.7031V10.0547H4.03516V21.7031H7.64453ZM5.83984 8.41406C6.98828 8.41406 7.91797 7.48438 7.91797 6.33594C7.91797 5.1875 6.98828 4.20312 5.83984 4.20312C4.63672 4.20312 3.70703 5.1875 3.70703 6.33594C3.70703 7.48438 4.63672 8.41406 5.83984 8.41406ZM21.2617 21.7031V15.3047C21.2617 12.1875 20.5508 9.72656 16.8867 9.72656C15.1367 9.72656 13.9336 10.7109 13.4414 11.6406H13.3867V10.0547H9.94141V21.7031H13.5508V15.9609C13.5508 14.4297 13.8242 12.9531 15.7383 12.9531C17.5977 12.9531 17.5977 14.7031 17.5977 16.0156V21.7031H21.2617Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b3dff34f7740c1716f1034217966511e.svg";
export { ForwardRef as ReactComponent };